// Plain ESM so the Lambdas can import it at runtime alongside the TS host rules.
export const NON_BRAND_SUBDOMAIN_LABELS = Object.freeze([
  'community',
  'communitystaging',
  'apply',
  'applystaging',
  'www',
  'api',
  'api2',
]);
